module.exports = __webpack_public_path__ + "static/img/benzbmw_th.06d6ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lucas/benzbmw_th.png
// module id = 3+7l
// module chunks = 1